import { NgModule } from '@angular/core';
import { MdbRippleDirective } from './ripple.directive';

@NgModule({
  declarations: [MdbRippleDirective],
  imports: [],
  exports: [MdbRippleDirective],
})
export class MdbRippleModule {}
